__turbopack_context__.v({
  "card": "templateTooltip-module-scss-module__nQDS8a__card",
  "currentCard": "templateTooltip-module-scss-module__nQDS8a__currentCard",
  "preview": "templateTooltip-module-scss-module__nQDS8a__preview",
  "rotationProgress": "templateTooltip-module-scss-module__nQDS8a__rotationProgress",
  "templateName": "templateTooltip-module-scss-module__nQDS8a__templateName",
});
